import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from '../../context/SnackbarProvider/SnackbarProvider'

const rejectDeal = async ({ PK, SK, requestor, approverId, reason }) => {
  try {
    const slackToken = localStorage.getItem('slack_access_token')
    if (!slackToken) {
      throw new Error('No authentication token available')
    }

    const response = await axios.post(
      `${baseUrl}/aws/organizations_table/${PK}/${SK}/reject`, // Pass the dealId correctly here
      { requestor, approverId, reason, slackToken }, // This is the payload with approverId
      {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: slackToken,
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error rejecting the deal:', error)
    throw error // Propagate the error to handle it properly in the mutation
  }
}

export const useRejectDeal = () => {
  const queryClient = useQueryClient()
  const { showSnackbar } = useSnackbarContext()

  const mutation = useMutation({
    mutationFn: rejectDeal,
    onSuccess: (data, variables) => {
      console.log('Deal rejected successfully:', data)
      showSnackbar('Deal rejected successfully', 'success')

      // Merge response data into item-level cache
      // Note: SEARCH_DATA_KEY is updated by the call-site via syncDealFields
      // Note: org-level cache is updated by the call-site after computing final status
      if (data?.deal) {
        queryClient.setQueryData(['item', variables.PK, variables.SK], (old: any) => {
          if (!old) return old
          return { ...old, ...data.deal }
        })
      }
    },
    onError: error => {
      console.error('Error in deal rejection process:', error)
      showSnackbar('Error during rejection', 'error')
    },
  })
  return mutation
}
